export default function offsetWallpaperForLeaderboard() {
	let hasAlreadyRun = false;

	const firstLeaderboard = document.querySelectorAll('[class$="leaderboard-ad"]')[0];

	if (firstLeaderboard) {
		const firstLeaderboardObserver = new MutationObserver((mutationList) => {
			mutationList.forEach((mutation) => {
				if (
					mutation.type === 'attributes'
					&& mutation.attributeName === 'data-load-complete'
					&& document.body.classList.contains('has-wallpaper')
					&& !hasAlreadyRun
				) {
					hasAlreadyRun = true;

					const header = document.getElementsByTagName('header')[0];

					const firstLeaderboardStyle = window.getComputedStyle(firstLeaderboard);

					const firstLeaderboardHeight = firstLeaderboard.getBoundingClientRect().height;

					const headerdHeight = header.getBoundingClientRect().height;

					const headerMarginBottom = parseInt(
						firstLeaderboardStyle['margin-bottom'].match(/\d+/)[0],
						10,
					);

					const headerMarginTop = parseInt(
						firstLeaderboardStyle['margin-top'].match(/\d+/)[0],
						10,
					);

					const offset = (
						firstLeaderboardHeight + headerdHeight + headerMarginBottom + headerMarginTop
					);

					document.body.style.backgroundPositionY = `${offset}px`;
				}
			});
		});

		firstLeaderboardObserver.observe(firstLeaderboard, { attributes: true, subtree: true });
	}
}
